"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorldTransportOverseasHellas = void 0;
exports.WorldTransportOverseasHellas = {
    id: 'worldTransportOverseasHellas',
    companyName: 'World Transport Overseas Hellas',
    transportModes: ['sea', 'air'],
    freightGate: {
        isOnboarded: true,
        realm: 'worldTransportOverseasHellas',
    },
    isInternal: false,
    isActive: true,
    countries: ['GR'],
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiV29ybGRUcmFuc3BvcnRPdmVyc2Vhc0hlbGxhcy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9hZ2VudHMvZGF0YS9Xb3JsZFRyYW5zcG9ydE92ZXJzZWFzSGVsbGFzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUVhLFFBQUEsNEJBQTRCLEdBQVU7SUFDL0MsRUFBRSxFQUFFLDhCQUE4QjtJQUNsQyxXQUFXLEVBQUUsaUNBQWlDO0lBQzlDLGNBQWMsRUFBRSxDQUFDLEtBQUssRUFBRSxLQUFLLENBQUM7SUFDOUIsV0FBVyxFQUFFO1FBQ1QsV0FBVyxFQUFFLElBQUk7UUFDakIsS0FBSyxFQUFFLDhCQUE4QjtLQUN4QztJQUNELFVBQVUsRUFBRSxLQUFLO0lBQ2pCLFFBQVEsRUFBRSxJQUFJO0lBQ2QsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDO0NBQ3BCLENBQUEifQ==